import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import useTranslationService, {
  translationService,
} from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { Coin } from "../../../components/shop/Coin";
import {
  activityPricesStorage,
  ActivityTypes,
} from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { useMemo } from "react";
import Tooltip from "@mui/material/Tooltip";

export interface SmartAppPreviewProps {
  title: string;
  image: string | React.ReactNode;
  description: string;
  action(): void;
  hasPadding?: Boolean;
  fontSizeMul: Number;
  name?: ActivityTypes;
}

export default observer(function SmartAppPreview(props: SmartAppPreviewProps) {
  const { title, image, description, action } = { ...props };
  const { translate } = useTranslationService();

  const costs = useMemo(
    () => activityPricesStorage.getPrice(props.name || 0),
    [activityPricesStorage, props.name]
  );

  return (
    <div onClick={action}>
      <Card elevation={10} style={{ cursor: "pointer" }}>
        <CardHeader
          title={translate(title)}
          subheader={
            <Typography variant="caption">
              {translate("general.bySarida")}
            </Typography>
          }
        />

        {typeof image === "string" ? (
          <CardMedia image={image} component="img" />
        ) : (
          image
        )}

        <CardContent
          style={{ transition: "900ms", fontSize: props.fontSizeMul + "rem" }}
        >
          <Tooltip title={translate(description)}>
            <Typography
              variant="body2"
              style={{
                flexGrow: 1,
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: "3",
                WebkitBoxOrient: "vertical",
                textOverflow: "ellipsis",
              }}
            >
              {translate(description)}
            </Typography>
          </Tooltip>
        </CardContent>
        {props.name && (
          <CardActions>
            <Stack marginLeft="auto" direction="row">
              <Coin
                text={translationService.translate("general.appCosts")}
                amount={costs}
              />
            </Stack>
          </CardActions>
        )}
      </Card>
    </div>
  );
});
